<template>
  <a-card title="Đăng nhập" class="root-card">
    <a-form-model layout="horizontal" class="centered-form">
      <a-form-model-item>
        <a-input placeholder="Username" v-model="loginCredentials.username">
          <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-model-item>
      <a-form-model-item>
        <a-input-password placeholder="Password" v-model="loginCredentials.password">
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item>
        <a-checkbox v-model="loginCredentials.remember">
          Remember
        </a-checkbox>
      </a-form-model-item>
      <a-form-model-item class="centered-btn"> 
        <a-button type="primary" @click="handleLogin" :loading="loginLoading">Đăng nhập</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<style scoped>
.centered-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  margin: 0 auto;
}

.centered-form .ant-form-item {
  margin-bottom: 10px;
}

.centered-form .ant-row {
  width: 300px;
}

.centered-btn {
  display: flex;
  justify-content: center;
  margin-bottom: 15px !important;
}
</style>

<script>
import {mapActions} from 'vuex';

export default {
  data() {
    return {
      loginCredentials: {
        username: undefined,
        password: undefined,
        remember: false
      },
      loginLoading: false
    }
  },
  methods: {
    ...mapActions('auth', {
      login: 'login'
    }),

    async handleLogin() {
      this.loginLoading = true;
      try {
        const {message} = await this.login(this.loginCredentials);
        this.$message.success(message);
        this.$router.push({name: 'Home'});
      }
      catch(error) {
        this.$message.error(error?.response?.data?.error?.message || error?.response?.data || error.message);

        if (error?.code == 'ERR_NETWORK') {
          this.$router.push({name: 'ServiceSetting'});
        }
      }
      this.loginLoading = false;
    }
  }
}
</script>
